<template>
  <div class="card card-custom" style="position: relative">
    <v-overlay :value="carregando" :absolute="true">
      <v-progress-circular
        indeterminate
        size="32"
        color="#462181"
        width="2"
      ></v-progress-circular>
    </v-overlay>
    <div class="card-body p-0">
      <div
        class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
      >
        <div class="d-flex flex-column w-100">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="card-titulo-icone mr-3"
                ><i class="fas fa-wallet"></i
              ></span>
              <h5 class="m-0 mr-3 card-titulo">Consumo</h5>
              <Tooltip
                message="O gráfico de estatísticas mensais representa os créditos do mês atual,  demonstrando o saldo utilizado e limite de créditos."
              />
            </div>
            <div>
              <b-button
                variant="success"
                size="sm"
                class="ml-2"
                style="
                  background: #472282 !important;
                  border-color: #472282 !important;
                "
                @click="toggle"
                ref="BotaoMenu"
              >
                {{ label_botao_menu }}
              </b-button>
              <div
                class="d-flex justify-content-center"
                style="position: relative"
                v-if="visible_menu_opcoes"
              >
                <Menu
                  ref="menu_togglable"
                  id="overlay_menu"
                  :model="messageChannelFilterOptions"
                  style="
                    position: absolute;
                    transform: translateY(4px);
                    z-index: 99;
                    right: 0;
                  "
                />
              </div>
            </div>
          </div>
          <!-- Mesma leitura da Central de Contas: percentual consumido,
          barra com cor por saudabilidade e o "X de Y" embaixo. -->
          <div
            class="consumo mt-3"
            v-b-tooltip.hover
            :title="'Saldo restante: ' + canal.saldo"
          >
            <div class="consumo__cabecalho">
              <span class="consumo__rotulo">Consumido</span>
              <span class="consumo__percentual" :class="corConsumo">
                {{ percentualConsumo }}%
              </span>
            </div>
            <div class="consumo__barra">
              <span
                class="consumo__uso"
                :class="corConsumo"
                :style="{ width: percentualConsumo + '%' }"
              ></span>
            </div>
            <div class="consumo__texto">
              {{ formatarInteiro(dados.limiteCredito - canal.saldo) }}
              <span class="consumo__total"
                >de {{ formatarInteiro(dados.limiteCredito) }} ·
                {{ plano }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import Menu from "primevue/menu";

export default {
  props: {
    dados: {
      type: Object,
      required: true
    },
    plano: {
      type: String,
      required: true
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opcoesGrafico: {},
      visible_menu_opcoes: false,
      label_botao_menu: "Todos",
      canal: {
        saldo:
          this.dados.limiteCredito -
          this.dados.totalWhatsapp -
          this.dados.totalSMS -
          this.dados.totalEmail
      }
    };
  },
  methods: {
    toggle() {
      this.visible_menu_opcoes = !this.visible_menu_opcoes;
    },
    clickAll() {
      this.label_botao_menu = "Todos";
      this.$refs.BotaoMenu.style.background = "#472282";
      this.$refs.BotaoMenu.style.borderColor = "#472282";
      this.updateAll();
      this.closeMenu();
    },
    clickWpp() {
      this.label_botao_menu = "WhatsApp";
      this.$refs.BotaoMenu.style.background = "#00a884";
      this.$refs.BotaoMenu.style.borderColor = "#00a884";
      this.updateWpp();
      this.closeMenu();
    },
    clickSMS() {
      this.label_botao_menu = "SMS";
      this.$refs.BotaoMenu.style.background = "#ff7f00";
      this.$refs.BotaoMenu.style.borderColor = "#ff7f00";
      this.updateSMS();
      this.closeMenu();
    },
    clickEmail() {
      this.label_botao_menu = "E-mail";
      this.$refs.BotaoMenu.style.background = "#3699ff";
      this.$refs.BotaoMenu.style.borderColor = "#3699ff";
      this.updateEmail();
      this.closeMenu();
    },
    closeMenu() {
      this.visible_menu_opcoes = false;
    },
    updateAll() {
      this.canal.saldo =
        this.dados.limiteCredito -
        this.dados.totalWhatsapp -
        this.dados.totalSMS -
        this.dados.totalEmail;
    },
    updateWpp() {
      let wppRecebimento = this.dados.recebimentosPorCanal.find(
        (i) => i.canal == "Whatsapp"
      ).quantidade;
      let wppEnvios = this.dados.enviosPorCanal.find(
        (i) => i.canal == "Whatsapp"
      ).quantidade;
      this.canal.saldo =
        parseInt(this.dados.limiteCredito) -
        parseInt(wppEnvios) -
        parseInt(wppRecebimento);
    },
    updateSMS() {
      let recebimento = this.dados.recebimentosPorCanal.find(
        (i) => i.canal == "SMS"
      ).quantidade;
      let envios = this.dados.enviosPorCanal.find(
        (i) => i.canal == "SMS"
      ).quantidade;
      this.canal.saldo =
        parseInt(this.dados.limiteCredito) -
        parseInt(envios) -
        parseInt(recebimento);
    },
    updateEmail() {
      let recebimento = this.dados.recebimentosPorCanal.find(
        (i) => i.canal == "E-Mail"
      ).quantidade;
      let envios = this.dados.enviosPorCanal.find(
        (i) => i.canal == "E-Mail"
      ).quantidade;
      this.canal.saldo =
        parseInt(this.dados.limiteCredito) -
        parseInt(envios) -
        parseInt(recebimento);
    }
  },
  computed: {
    // Percentual CONSUMIDO (0 -> 100), mesma perspectiva da Central.
    percentualConsumo() {
      const limite = Number(this.dados.limiteCredito) || 0;
      if (limite <= 0) return 0;
      const consumido = limite - Number(this.canal.saldo || 0);
      return Math.max(0, Math.min(100, Math.round((consumido / limite) * 100)));
    },
    // Mesmos limiares da Central: >= 85% critico, >= 60% alerta.
    corConsumo() {
      if (this.percentualConsumo >= 85) return "consumo--critico";
      if (this.percentualConsumo >= 60) return "consumo--alerta";
      return "";
    },
    messageChannelFilterOptions() {
      let options = [
        {
          label: "Todos",
          command: this.clickAll
        },
        {
          label: "WhatsApp",
          command: this.clickWpp
        },
        {
          label: "SMS",
          command: this.clickSMS
        },
        {
          label: "E-mail",
          command: this.clickEmail
        }
      ];
      if (!this.totalSMS && this.totalSMS == 0) {
        options = options.filter((i) => i.label != "SMS");
      }
      if (!this.totalWhatsapp && this.totalWhatsapp == 0) {
        options = options.filter((i) => i.label != "WhatsApp");
      }
      if (!this.totalEmail && this.totalEmail == 0) {
        options = options.filter((i) => i.label != "E-mail");
      }
      if (options.length <= 2) {
        options = options.filter((i) => i.label != "Todos");
      }
      return options;
    }
  },
  watch: {
    dados() {
      this.updateAll();
    }
  },
  components: { Tooltip, Menu }
};
</script>

<style lang="scss" scoped>
::v-deep .progress-bar.bg-success {
  background-color: #472282 !important;
}
::v-deep .progress-bar.bg-warning {
  background-color: #ff7f00 !important;
}
.card {
  transition: 0.3s ease;
  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
}

// Espelha o bloco de saldo da Central de Contas (WEL-5152/5194): mesma
// leitura de consumo, mesmos limiares e as mesmas cores.
.consumo__cabecalho {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.35rem;
}

.consumo__rotulo {
  font-size: 0.8rem;
  font-weight: 600;
  color: #7c7c8a;
}

.consumo__percentual {
  font-size: 0.9rem;
  font-weight: 700;
  color: #472282;
  line-height: 1.2;

  &.consumo--alerta {
    color: #d97706;
  }

  &.consumo--critico {
    color: #b42335;
  }
}

.consumo__barra {
  height: 6px;
  border-radius: 999px;
  background: #eeecf3;
  overflow: hidden;
}

.consumo__uso {
  display: block;
  height: 100%;
  border-radius: 999px 0 0 999px;
  background: linear-gradient(90deg, #8950fc 0%, #472282 100%);
  transition: width 0.3s ease, background 0.3s ease;

  &.consumo--alerta {
    background: linear-gradient(90deg, #f0ad4e 0%, #d97706 100%);
  }

  &.consumo--critico {
    background: linear-gradient(90deg, #e2536b 0%, #b42335 100%);
  }
}

.consumo__texto {
  margin-top: 0.4rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #2b2640;
}

.consumo__total {
  font-weight: 500;
  color: #7c7c8a;
}
</style>
